import { useQuery } from '@tanstack/react-query';
import { api, ApiError } from '@shared/lib/api';
import { qk } from '@shared/lib/query-keys';
import type { AdminUser } from '@shared/types';

interface SessionResponse {
  user: AdminUser | null;
}

export function useSession() {
  return useQuery({
    queryKey: qk.session,
    queryFn: async (): Promise<AdminUser | null> => {
      try {
        const res = await api<SessionResponse>('/api/admin/me');
        return res.user;
      } catch (e) {
        if (e instanceof ApiError && e.status === 401) return null;
        throw e;
      }
    },
    staleTime: 30_000,
    retry: false,
  });
}
